import React from 'react';
import { cx } from '@emotion/css';
import { IconButton as MUIIconButton } from '@mui/material';
import { useIconButtonStyles } from './IconButton.styles';
export function IconButton(props) {
    const classes = useIconButtonStyles(props);
    function getVariantClassName() {
        return classes[`IconButton-${props.variant || 'text'}`];
    }
    return (React.createElement(MUIIconButton, { id: props.id, className: cx(classes.default, getVariantClassName(), props.className), classes: props.classes, children: props.children, disabled: props.disabled, onClick: props.onClick, onMouseDown: props.onMouseDown, size: props.size, edge: props.edge }));
}
//# sourceMappingURL=IconButton.js.map